export const FETCH_REQUEST_FAILURE = 'FETCH_REQUEST_FAILURE';
export const FETCH_REQUEST_LOADING = 'FETCH_REQUEST_LOADING';
export const FETCH_REQUEST_SUCCESS = 'FETCH_REQUEST_SUCCESS';

export const DELETE_REQUEST_LOADING = 'DELETE_REQUEST_LOADING';
export const DELETE_REQUEST_SUCCESS = 'DELETE_REQUEST_SUCCESS';
export const DELETE_REQUEST_FAILURE = 'DELETE_REQUEST_FAILURE'; 